<template>
  <div>
    <v-col class="heading pb-0" cols="12" align="Left">
      Frequently Asked Questions regarding the workshops
    </v-col>
    <v-col align="center pt-0" cols="12" class="my-2">
      <v-expansion-panels flat>
        <v-expansion-panel
          v-for="(item, i) in faqs"
          :key="i"
          class="expansion-card"
          active-class="faqActiveClass"
        >
          <v-expansion-panel-header class="expansion-heading">
            {{ item.question }}
          </v-expansion-panel-header>
          <v-expansion-panel-content class="expansion-text" align="Left">
            {{ item.answer }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </div>
</template>

<script>
  export default {
    name: "MembershipFAQ",
    components: {},
    data() {
      return {
        faqs: [
          {
            question: "How can I join the workshop?",
            answer:
              "Register for the workshop by sharing your details. After successful registration, you will receive a link to join the workshop in the email id you have entered.",
          },
          {
            question: "Will I get reminders about the workshop?",
            answer:
              "Yes, you will receive two reminders: one a day before and another an hour before the workshop begins.",
          },
          {
            question:
              "Can I ask questions from the expert during the workshop?",
            answer:
              "Yes, we will have a Q&A session as part of the session, where you can ask your questions directly to the expert and the expert will take as many questions as they can.",
          },
          {
            question: "Is there any cost to attend the workshop?",
            answer:
              "Yes, there is a small fee associated with it, you can find out more information about it on the workshop details page. However, with Eblity Membership, you can attend it for free.",
          },
          {
            question: "Would I get a certificate for this workshop?",
            answer:
              "Yes, you will receive a certificate with the signature of the expert conducting the workshop.",
          },
        ],
      };
    },
    created() {},
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
  };
</script>
<style scoped>
  .heading {
    font-weight: 900;
    font-size: 21px;
    line-height: 32px;
    color: #333333;
  }
  .expansion-card {
    margin-bottom: 10px;
    background: #ffffff;
    border: 1px solid rgba(51, 51, 51, 0.15);
    border-radius: 5px;
  }
  .expansion-heading {
    font-style: normal;
    font-weight: 900;
    font-size: 17px;
    line-height: 35px;
    color: #333333;
  }
  .expansion-text {
    font-weight: normal;
    font-size: 16px;
    line-height: 30px;
    color: #333333;
    opacity: 0.7;
  }
</style>
